import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChatLocationDirective } from './chat-location/chat-location.directive';
import { AuthInterceptorProvider } from "../services/token/token-interceptor.service";

@NgModule({
  declarations: [
      ChatLocationDirective
  ],
  imports: [
      CommonModule,
  ],
  exports: [ 
      ChatLocationDirective
  ],
  providers: [
    AuthInterceptorProvider,
]
})
export class SharedModule {}